import { render, staticRenderFns } from "./dingdan-table.vue?vue&type=template&id=3895728b&scoped=true&"
import script from "./dingdan-table.vue?vue&type=script&lang=js&"
export * from "./dingdan-table.vue?vue&type=script&lang=js&"
import style0 from "./dingdan-table.vue?vue&type=style&index=0&id=3895728b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3895728b",
  null
  
)

export default component.exports